import React, { useCallback, useState, useRef } from 'react';
import { xhr, funBackground } from './util';
import { ApiResponse, User, UserLoginRequest, UserLoginResponse, HOST } from './types';
import './App.scss';

function Login({ setUser }: { setUser: React.Dispatch<React.SetStateAction<User>> }) {
  const [tab, setTab] = useState('login');
  const [message, setMessage] = useState<string|null>(null);
  const [error, setError] = useState<string|null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const changeTab = useCallback((tab: string) => {
    setTab(tab);
  }, []);
  const request = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    if (usernameRef.current && passwordRef.current) {
      const username = usernameRef.current.value;
      const password = passwordRef.current.value;
      console.log(`Getting a user,

        ${HOST}/${tab}-user
      `)
      if (username && password) {
        setLoading(true);
        xhr({
          method: 'POST',
          url: `${HOST}/${tab}-user`,
          body: { 
            userName: username, 
            password: password 
          } as UserLoginRequest
        }).then((res: ApiResponse) => {
          setLoading(false);
          if (res.success) {
            if (tab == 'login') {
              setUser(res.user as User);
            } else if (res.message) {
              setError(null);
              setMessage(res.message);
            }
          } else {
            setError(res.message || '');
          }
        })
      }
    }
  }, [usernameRef, passwordRef, tab]);
  const [styleA, styleB, styleC, styleD] = funBackground(500);
  return (
    <form id="Login" onSubmit={(event) => request(event)}>
      <h1 style={{
        color: 'black',
        width: '60%',
        fontSize: '3rem',
      }}>FINANCE<br/>CALENDAR</h1>
      <div className="Tab-Container">
        <div className="Tabs">
          <button type="button" onClick={() => changeTab('login')} className={tab === 'login' ? 'active' : ''}>Login</button>
          <button type="button" onClick={() => changeTab('register')} className={tab === 'register' ? 'active' : ''}>Register</button>
        </div>
        <div className="Tab-Content" >
          <input type="text" placeholder="Username" ref={usernameRef} />
          <input type="password" placeholder="Password" ref={passwordRef} />
          {
            tab == 'login' ?
              
              <button className="auth-button" type="submit" onClick={(event) => request(event)}>{loading ? <span className="loading"></span> : <span>Login</span>}</button>
              
              :

              <button className="auth-button" type="submit" onClick={(event) => request(event)}>{loading ? <span className="loading"></span> : <span>Register</span>}</button>
          
          }
        </div>
        <p className="error">{ error || null }</p>
        <p className="message">{ message || null }</p>
      </div>
    </form>
  );
}

export default Login;
